import { useGetEmailTemplates } from 'modules/email/hooks/use-get-email-templates';
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import EmailTemplateSelector from './email-template-selector';
interface EmailTemplateSelectorNewEditorModalProps {
  opened: boolean;
  onChoose: (templateId: number) => Promise<void>;
  onClose: () => void;
}
const EmailTemplateSelectorNewEditorModal = ({
  opened,
  onChoose,
  onClose
}: EmailTemplateSelectorNewEditorModalProps) => {
  const [isFetching, setIsFetching] = useState(false);
  const {
    t
  } = useLocoTranslation();
  const [chosenTemplateId, setChosenTemplateId] = useState<number>();
  const {
    templates
  } = useGetEmailTemplates();
  useEffect(() => {
    if (templates) {
      setChosenTemplateId(templates?.[0]?.id);
    }
  }, [templates]);
  const submit = async () => {
    if (!chosenTemplateId) return;
    setIsFetching(true);
    try {
      await onChoose(chosenTemplateId);
    } catch {} finally {
      setIsFetching(false);
    }
  };
  return <Modal opened={opened} onClose={onClose} title={t('dashboard.email_template_selector.choose_template_label')} isFetching={isFetching}>
      <EmailTemplateSelector onChange={template => setChosenTemplateId(template)} templateId={chosenTemplateId} templates={templates} />
      <div className="tablet:[&>*]:flex-none tablet:[&>*]:w-auto flex justify-end [&>*]:flex-1">
        <Button disabled={!chosenTemplateId} onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        submit();
      }} type="submit" isLoading={isFetching} variant="primary" size="md">
          {t('global.confirm')}
        </Button>
      </div>
    </Modal>;
};
export default EmailTemplateSelectorNewEditorModal;